import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseSelectProps } from '~/components/inputs/Select/Select';
import SimpleSelect, { SimpleSelectOption } from '~/components/inputs/Select/SimpleSelect';
import { FiscalRegime } from '~/types/company';

interface Props extends BaseSelectProps {
  onChange: (value: FiscalRegime) => void;
  value: FiscalRegime | null;
}

const FiscalRegimeSelect = forwardRef<HTMLDivElement, Props>(({ onChange, ...props }, ref) => {
  const { t } = useTranslation('inputs');
  const options: SimpleSelectOption[] = [
    FiscalRegime.RF01,
    FiscalRegime.RF02,
    FiscalRegime.RF04,
    FiscalRegime.RF05,
    FiscalRegime.RF06,
    FiscalRegime.RF07,
    FiscalRegime.RF08,
    FiscalRegime.RF09,
    FiscalRegime.RF10,
    FiscalRegime.RF11,
    FiscalRegime.RF12,
    FiscalRegime.RF13,
    FiscalRegime.RF14,
    FiscalRegime.RF15,
    FiscalRegime.RF16,
    FiscalRegime.RF17,
    FiscalRegime.RF18,
    FiscalRegime.RF19,
    FiscalRegime.RF20,
  ].map((value) => ({ value, label: `${value} — ${t(`fiscal_regime_select.${value}`)}` }));
  return <SimpleSelect {...props} ref={ref} onChange={(value) => onChange(value as FiscalRegime)} options={options} />;
});

export default FiscalRegimeSelect;
